import { useCallback, useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Flex } from 'foundations-components/components/Flex';
import debounce from 'transmute/debounce';
import { getSelectedDealIds, getShowSubmissionPanelFromDealTable } from '../../selectors/dealsSelectors';
import { updateSelectedDeals } from '../../utils/deals';
import { setSelectedDealIds, setShowSubmissionPanelFromDealTable } from '../../actions/DealsActions';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { trackDeselectDealFromDealTable, trackOpenSubmissionPanelBySelectingDeal, trackSelectDealFromDealTable } from '../../utils/usageTracker';
import { useSubmitForecastDisabledTooltipTitle } from '../frameworkDealTable/hooks/useSubmitForecastDisabledTooltipTitle';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getForecastTypeFilter } from '../../selectors/filtersSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_DELAY = 300;
const ForecastedCell = ({
  row
}) => {
  const dispatch = useDispatch();
  const selectedDealIds = useSelector(getSelectedDealIds);
  const isDealStageView = useSelector(getIsDealStageView);
  const isSubmissionPanelOpen = useSelector(getShowSubmissionPanelFromDealTable);
  const submitForecastDisabledTooltipTitle = useSubmitForecastDisabledTooltipTitle();
  const forecastTypeId = useSelector(getForecastTypeFilter);
  const dealId = Number(row.id);
  const [isChecked, setIsChecked] = useState(selectedDealIds === null || selectedDealIds === void 0 ? void 0 : selectedDealIds.includes(dealId));

  // Keep isChecked in sync with selectedDealIds changes, which changes when a different Forecast Type is selected

  useEffect(() => {
    setIsChecked(selectedDealIds === null || selectedDealIds === void 0 ? void 0 : selectedDealIds.includes(dealId));
  }, [selectedDealIds, dealId]);
  const debouncedDispatchSelectedDeals = useMemo(() => debounce(
  // No debounce needed for opening the submission panel
  isSubmissionPanelOpen ? DEBOUNCE_DELAY : 0, updatedDeals => {
    dispatch(setSelectedDealIds(updatedDeals));
    if (!isSubmissionPanelOpen) {
      dispatch(setShowSubmissionPanelFromDealTable(true));
      trackOpenSubmissionPanelBySelectingDeal(isDealStageView);
    }
  }), [dispatch, isDealStageView, isSubmissionPanelOpen]);
  const handleOnChange = useCallback(event => {
    const checked = event.target.checked;

    // Update local state immediately for UI responsiveness
    setIsChecked(checked);
    const updatedSelectedDeals = updateSelectedDeals(row, checked, selectedDealIds);

    // Debounce the state update that triggers API calls in the submission panel
    debouncedDispatchSelectedDeals(updatedSelectedDeals);
    if (checked) {
      trackSelectDealFromDealTable(isDealStageView);
    } else {
      trackDeselectDealFromDealTable(isDealStageView);
    }
  }, [debouncedDispatchSelectedDeals, isDealStageView, row, selectedDealIds]);
  return /*#__PURE__*/_jsx("td", {
    children: /*#__PURE__*/_jsx(UITooltip, {
      "data-test-id": "forecasted-checkbox-disabled-tooltip",
      placement: "bottom",
      disabled: !submitForecastDisabledTooltipTitle,
      title: submitForecastDisabledTooltipTitle,
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(Checkbox, {
          // needs this key to rerender when forecastTypeId changes
          "data-test-id": "forecasted-checkbox",
          checked: isChecked,
          id: row.id,
          onChange: handleOnChange,
          disabled: !!submitForecastDisabledTooltipTitle
        }, `${row.id}-${forecastTypeId}`)
      })
    })
  });
};
export default ForecastedCell;